import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 's18-handicap-plus',
  templateUrl: './handicap-plus.component.html',
  styleUrls: ['./handicap-plus.component.scss']
})
export class HandicapPlusComponent implements OnInit {

  constructor(
    private router : Router
  ) { }

  ngOnInit() {
  }

  startNow(){
    this.router.navigateByUrl("/register");
  }

  getApp(){
    window.location.href = "https://app.golfgameskeeper.com";
  }

}
